const Pages = {
  // todo fill
  plugins: '/plugins'
}

export default Pages;
